export enum HeaderConditionType {
    Empty = "",
    Equal = "equal",
    NotEqual = "not_equal",
    Contains = "contains",
    DoesNotContain = "not_contains"
}